import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Page } from '../../../contexts/kioskConfiguration/type';
import { SignpostTemplate, SignpostTemplateType } from '../signpost/SignpostTemplate';
import {
  setFetchedTransportation,
  setTransportationForm, transportationFormInitialState
} from '../../../store/slices/transportation/transportationSlice';


type Props = {
  page: Page<SignpostTemplateType>
}

export const UnloadingSignpostTemplate = (props: Props): React.ReactElement => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setFetchedTransportation(null))
    dispatch(setTransportationForm({
      ...transportationFormInitialState,
    }))
  }, []);

  return (
    <SignpostTemplate page={props.page} />
  )
}
